var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
import { EventSourceParserStream } from 'eventsource-parser/stream';
import { EdenFetchError } from './errors.js';
// import { EdenWS } from './ws'
import { parseStringifiedValue } from './utils.js';
const method = [
    'get',
    'post',
    'put',
    'delete',
    'patch',
    'options',
    'head',
    'connect',
    'subscribe',
];
const isServer = typeof FileList === 'undefined';
const isFile = (v) => {
    if (isServer)
        return v instanceof Blob;
    return v instanceof FileList || v instanceof File;
};
// FormData is 1 level deep
const hasFile = (obj) => {
    if (!obj)
        return false;
    for (const key in obj) {
        if (isFile(obj[key]))
            return true;
        if (Array.isArray(obj[key]) && obj[key].find(isFile))
            return true;
    }
    return false;
};
const createNewFile = (v) => isServer
    ? v
    : new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
            const file = new File([reader.result], v.name, {
                lastModified: v.lastModified,
                type: v.type,
            });
            resolve(file);
        };
        reader.readAsArrayBuffer(v);
    });
const processHeaders = (h, path, options = {}, headers = {}) => {
    if (Array.isArray(h)) {
        for (const value of h)
            if (!Array.isArray(value))
                headers = processHeaders(value, path, options, headers);
            else {
                const key = value[0];
                if (typeof key === 'string')
                    headers[key.toLowerCase()] = value[1];
                else
                    for (const [k, value] of key)
                        headers[k.toLowerCase()] = value;
            }
        return headers;
    }
    if (!h)
        return headers;
    switch (typeof h) {
        case 'function':
            if (typeof Headers !== 'undefined' && h instanceof Headers)
                return processHeaders(h, path, options, headers);
            const v = h(path, options);
            if (v)
                return processHeaders(v, path, options, headers);
            return headers;
        case 'object':
            if (typeof Headers !== 'undefined' && h instanceof Headers) {
                h.forEach((value, key) => {
                    headers[key.toLowerCase()] = value;
                });
                return headers;
            }
            for (const [key, value] of Object.entries(h))
                headers[key.toLowerCase()] = value;
            return headers;
        default:
            return headers;
    }
};
export class TextDecoderStream extends TransformStream {
    constructor() {
        const decoder = new TextDecoder('utf-8', {
            fatal: true,
            ignoreBOM: true,
        });
        super({
            transform(chunk, controller) {
                const decoded = decoder.decode(chunk, { stream: true });
                if (decoded.length > 0) {
                    controller.enqueue(decoded);
                }
            },
            flush(controller) {
                const output = decoder.decode();
                if (output.length > 0) {
                    controller.enqueue(output);
                }
            },
        });
    }
}
export function streamSSEResponse(response) {
    return __asyncGenerator(this, arguments, function* streamSSEResponse_1() {
        const body = response.body;
        if (!body)
            return yield __await(void 0);
        const eventStream = response.body
            .pipeThrough(new TextDecoderStream())
            .pipeThrough(new EventSourceParserStream());
        let reader = eventStream.getReader();
        while (true) {
            const { done, value: event } = yield __await(reader.read());
            if (done)
                break;
            if ((event === null || event === void 0 ? void 0 : event.event) === 'error') {
                throw new EdenFetchError(500, event.data);
            }
            if (event) {
                yield yield __await(tryParsingJson(event.data));
            }
        }
    });
}
function tryParsingJson(data) {
    try {
        return JSON.parse(data);
    }
    catch (error) {
        return null;
    }
}
const createProxy = (domain, config, paths = [], instance) => new Proxy(() => { }, {
    get(_, param) {
        return createProxy(domain, config, param === 'index' ? paths : [...paths, param], instance);
    },
    apply(_, __, [body, options]) {
        if (!body ||
            options ||
            (typeof body === 'object' && Object.keys(body).length !== 1) ||
            method.includes(paths.at(-1))) {
            const methodPaths = [...paths];
            const method = methodPaths.pop();
            const path = '/' + methodPaths.join('/');
            let { fetch: fetcher = fetch, headers, onRequest, onResponse } = config;
            const isGetOrHead = method === 'get' || method === 'head' || method === 'subscribe';
            headers = processHeaders(headers, path, options);
            const query = isGetOrHead
                ? body === null || body === void 0 ? void 0 : body.query
                : options === null || options === void 0 ? void 0 : options.query;
            let q = '';
            if (query) {
                const append = (key, value) => {
                    q +=
                        (q ? '&' : '?') +
                            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                };
                for (const [key, value] of Object.entries(query)) {
                    if (Array.isArray(value)) {
                        for (const v of value)
                            append(key, v);
                        continue;
                    }
                    if (typeof value === 'object') {
                        append(key, JSON.stringify(value));
                        continue;
                    }
                    append(key, `${value}`);
                }
            }
            // if (method === 'subscribe') {
            // 	const url =
            // 		domain.replace(
            // 			/^([^]+):\/\//,
            // 			domain.startsWith('https://')
            // 				? 'wss://'
            // 				: domain.startsWith('http://')
            // 					? 'ws://'
            // 					: locals.find((v) =>
            // 								(domain as string).includes(v)
            // 						  )
            // 						? 'ws://'
            // 						: 'wss://'
            // 		) +
            // 		path +
            // 		q
            // 	return new EdenWS(url)
            // }
            return (async () => {
                var _a, _b;
                let fetchInit = {
                    method: method === null || method === void 0 ? void 0 : method.toUpperCase(),
                    body,
                    // ...conf,
                    headers,
                };
                fetchInit.headers = Object.assign(Object.assign({}, headers), processHeaders(
                // For GET and HEAD, options is moved to body (1st param)
                isGetOrHead ? body === null || body === void 0 ? void 0 : body.headers : options === null || options === void 0 ? void 0 : options.headers, path, fetchInit));
                const fetchOpts = isGetOrHead && typeof body === 'object'
                    ? body.fetch
                    : options === null || options === void 0 ? void 0 : options.fetch;
                fetchInit = Object.assign(Object.assign({}, fetchInit), fetchOpts);
                if (isGetOrHead)
                    delete fetchInit.body;
                if (onRequest) {
                    if (!Array.isArray(onRequest))
                        onRequest = [onRequest];
                    for (const value of onRequest) {
                        const temp = await value(path, fetchInit);
                        if (typeof temp === 'object')
                            fetchInit = Object.assign(Object.assign(Object.assign({}, fetchInit), temp), { headers: Object.assign(Object.assign({}, fetchInit.headers), processHeaders(temp.headers, path, fetchInit)) });
                    }
                }
                // ? Duplicate because end-user might add a body in onRequest
                if (isGetOrHead)
                    delete fetchInit.body;
                if (hasFile(body)) {
                    const formData = new FormData();
                    // FormData is 1 level deep
                    for (const [key, field] of Object.entries(fetchInit.body)) {
                        if (isServer) {
                            formData.append(key, field);
                            continue;
                        }
                        if (field instanceof File) {
                            formData.append(key, await createNewFile(field));
                            continue;
                        }
                        if (field instanceof FileList) {
                            for (let i = 0; i < field.length; i++)
                                formData.append(key, await createNewFile(field[i]));
                            continue;
                        }
                        if (Array.isArray(field)) {
                            for (let i = 0; i < field.length; i++) {
                                const value = field[i];
                                formData.append(key, value instanceof File ? await createNewFile(value) : value);
                            }
                            continue;
                        }
                        formData.append(key, field);
                    }
                    // We don't do this because we need to let the browser set the content type with the correct boundary
                    // fetchInit.headers['content-type'] = 'multipart/form-data'
                    fetchInit.body = formData;
                }
                else if (typeof body === 'object') {
                    ;
                    fetchInit.headers['content-type'] =
                        'application/json';
                    fetchInit.body = JSON.stringify(body);
                }
                else if (body !== undefined && body !== null) {
                    ;
                    fetchInit.headers['content-type'] =
                        'text/plain';
                }
                if (isGetOrHead)
                    delete fetchInit.body;
                if (onRequest) {
                    if (!Array.isArray(onRequest))
                        onRequest = [onRequest];
                    for (const value of onRequest) {
                        const temp = await value(path, fetchInit);
                        if (typeof temp === 'object')
                            fetchInit = Object.assign(Object.assign(Object.assign({}, fetchInit), temp), { headers: Object.assign(Object.assign({}, fetchInit.headers), processHeaders(temp.headers, path, fetchInit)) });
                    }
                }
                const url = domain + path + q;
                const response = await ((_a = instance === null || instance === void 0 ? void 0 : instance.handle(new Request(url, fetchInit))) !== null && _a !== void 0 ? _a : fetcher(url, fetchInit));
                let data = null;
                let error = null;
                if (onResponse) {
                    if (!Array.isArray(onResponse))
                        onResponse = [onResponse];
                    for (const value of onResponse)
                        try {
                            const temp = await value(response.clone());
                            if (temp !== undefined && temp !== null) {
                                data = temp;
                                break;
                            }
                        }
                        catch (err) {
                            if (err instanceof EdenFetchError)
                                error = err;
                            else
                                error = new EdenFetchError(422, err);
                            break;
                        }
                }
                if (data !== null) {
                    return {
                        data,
                        error,
                        response,
                        status: response.status,
                        headers: response.headers,
                    };
                }
                switch ((_b = response.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.split(';')[0]) {
                    case 'text/event-stream':
                        data = streamSSEResponse(response);
                        break;
                    case 'application/json':
                        data = await response.json();
                        break;
                    case 'application/octet-stream':
                        data = await response.arrayBuffer();
                        break;
                    case 'multipart/form-data':
                        const temp = await response.formData();
                        data = {};
                        temp.forEach((value, key) => {
                            // @ts-ignore
                            data[key] = value;
                        });
                        break;
                    default:
                        data = await response.text().then(parseStringifiedValue);
                }
                if (response.status >= 300 || response.status < 200) {
                    error = new EdenFetchError(response.status, data);
                    data = null;
                }
                return {
                    data,
                    error,
                    response,
                    status: response.status,
                    headers: response.headers,
                };
            })();
        }
        if (typeof body === 'object')
            return createProxy(domain, config, [...paths, Object.values(body)[0]], instance);
        return createProxy(domain, config, paths);
    },
});
export const createSpiceflowClient = (domain, config = {}) => {
    if (typeof domain === 'string') {
        if (domain.endsWith('/'))
            domain = domain.slice(0, -1);
        return createProxy(domain, config);
    }
    if (typeof window !== 'undefined')
        console.warn('Spiceflow instance server found on client side, this is not recommended for security reason. Use generic type instead.');
    return createProxy('http://e.ly', config, [], domain);
};
//# sourceMappingURL=index.js.map